import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';
import { getCookies } from '../../helpers/storage';

interface PostGenerateOtp {
    phone: string
}

interface PostLogin {
    otp: string,
    phone: string
}

interface AddPostResponse {
    id: number;
    title: string;
    content: string;
    userId: number;
}

export const authApi: any = createApi({
    reducerPath: 'authApi',
    baseQuery: axiosBaseQuery(),
    endpoints: (builder) => ({
        generateOtp: builder.mutation<any, Partial<any>>({
            query: (newPost) => ({
                url: '/auth/otp/generate',
                method: 'POST',
                data: newPost,
                headers: { 'No-Auth': 'true' }
            }),
        }),
        login: builder.mutation<AddPostResponse, Partial<PostLogin>>({
            query: (newPost) => ({
                url: '/auth/login',
                method: 'POST',
                data: newPost,
                headers: { 'No-Auth': 'true' }
            }),
        }),
        logout: builder.mutation<any, void>({
            query: () => ({
                url: '/auth/logout',
                method: 'POST',
                headers: { "refreshToken" : getCookies('refreshToken') }
            }),
        }),
    }),
});

export const { useGenerateOtpMutation, useLoginMutation, useLogoutMutation } = authApi;
